<template>
  <span class="name-code">
    <span class="name">{{ name }}</span>
    <span v-if="code" class="code">- {{ code }}</span>
  </span>
</template>

<script>
export default {
  name: "ParamsNameWithCodeRenderer",
  // props: { params: { type: Object, required: true } },
  computed: {
    name() { return this.params?.data?.name || ""; },
    code() { return this.params?.data?._code || ""; },
  },
};
</script>

<style scoped>
.name-code { display: inline-flex; align-items: center; gap: 6px; }
.name { color: #111827; }           /* gray-900 */
.code { color: #9ca3af; }           /* gray-400 = เทาจาง */
</style>